



















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  inheritAttrs: false,
})
export default class InputComponent extends Vue {
  @Prop({ default: '', type: [String, Object] }) public readonly inputClass!:
    | string
    | object;
  @Prop({ default: 80, type: Number }) public readonly maxChars!: number;
  @Prop({ default: false, type: Boolean })
  public readonly showCharsCount!: boolean;
  @Prop({ default: 'text', type: String }) public readonly type!: string;
  @Prop(String) public readonly value!: string;

  get charsCount() {
    return this.value.length + ' / ' + this.maxChars;
  }
}
